import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import 'rxjs/add/operator/map'
import { ExportPPTService } from 'app/service/export-ppt.service'
@Component({
  selector: 'app-capital-raised-instruments',
  templateUrl: './capital-raised-instruments.component.html',
  styleUrls: ['./capital-raised-instruments.component.scss']
})
export class CapitalRaisedInstrumentsComponent implements OnInit, OnDestroy, AfterViewInit {
  dataChart3
  getPrint
  chart3
  form: FormGroup
  capListso
  capHeaderso
  capTypeso
  capSo
  marketListipo = []
  marketHeadipo
  marketTypeipo
  marketCapIpo
  startYear
  endYear
  charts = {}
  totals = []
  totals2 = []
  showTable = []
  showTable2 = []
  ytdValue = 0
  textMark
  tradingDate
  pdfChart: PdfChart = new PdfChart()
  indexName = ['SET', 'mai', 'IFF', 'REIT']
  radios = [
    { value: '1', des: 'IPO (SET, mai, IFF, PF&REITs)' },
    { value: '2', des: 'SO (PP, PO, RO, SD, XE, Others)' }
  ]
  radios2 = [
    { value: 'M', des: 'Market cap' },
    { value: 'C', des: 'Capital raised' }
  ]
  currentItem = '1'
  currentItem2 = 'M'
  ipoTable = []
  listIpoTable = []
  listSoTable = []
  dataProviderForIpo = []
  dataProviderForSo = []
  dataExportExcelIpo = []
  dataExportExcelSo = []
  textHeader
  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() {
    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )

    const { capitalValue } = this.activatedRoute.snapshot.params // 1,2
    const { capitalType } = this.activatedRoute.snapshot.params // M  ,  C
    const { print } = this.activatedRoute.snapshot.data

    this.getPrint = print;


    capitalValue === undefined
      ? (this.currentItem = '1')
      : (this.currentItem = capitalValue)
    capitalType === undefined
      ? (this.currentItem2 = 'M')
      : (this.currentItem2 = capitalType)
    const { pdf } = this.activatedRoute.snapshot.data
    this.pdfChart.setPdf(pdf)

    this.form = new FormGroup({
      radioValue: new FormControl(this.currentItem),
      radioValue2: new FormControl(this.currentItem2)
    })
  }

  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    this.startYear = +this.endYear - 4
    this.onChangeData()
  }

  onChangeData() {
    if (this.currentItem2 === 'M') {
      this.textMark = 'Market cap'
    } else {
      this.textMark = 'Capital raised'
    }
    if (this.currentItem === '1') {
      this.textHeader = 'IPO'
    } else {
      this.textHeader = 'SO'
    }
    this.showTable = []
    this.cpmService
      .getCapitaValueIPO(
        this.form.get('radioValue2').value,
        this.startYear,
        this.endYear
      )
      .subscribe(obj => {
        this.marketListipo = []
        obj.map(value => {
          this.marketListipo.push(value)
        })
        this.marketHeadipo = obj.map(headermarketIpo => headermarketIpo.year)
        this.marketTypeipo = obj.map(mtypeIpo => mtypeIpo.type)
        this.marketCapIpo = obj.map(marketIpo => marketIpo.capitalValue)
        this.marketHeadipo = this.marketHeadipo.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.marketTypeipo = this.marketTypeipo.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.ipoTable = []
        this.marketTypeipo.map(type => {
          const listIpo = []
          listIpo.push(type)
          this.marketListipo.filter(ipo => ipo.type === type).map(ipoValue => {
            listIpo.push(ipoValue.capitalValue)
          })
          const xx = [...listIpo]
          this.ipoTable.push(xx)
        })
        this.marketTypeipo.push('Total')
        let list = []
        const listTable = []
        this.totals = this.marketHeadipo.map(header => {
          list = []
          this.marketTypeipo.map(type => {
            this.marketListipo.map(ipo => {
              if (header === ipo.year && type === ipo.type) {
                list.push(ipo.capitalValue)
              }
            })
          })

          const tmp = [...list]
          tmp.unshift(header)
          listTable.push(tmp)
          const Total = {
            year: header,
            value: list.reduce((a, b) => Math.round(a) + Math.round(b), 0)
          }
          this.showTable.push(list)

          this.listIpoTable = [...listTable]
          return Total
        })
        this.dataProviderForIpo = []
        this.dataProviderForIpo = this.listIpoTable.map((ipo, i) => {

          const ipoObj = {
            year: ipo[0],
            set: Math.round(ipo[1]),
            mai: Math.round(ipo[2]),
            iff: Math.round(ipo[3]),
            reit: Math.round(ipo[4])
          }
          return ipoObj
        })
        this.dataExportExcelIpo = []
        this.dataExportExcelIpo = this.dataProviderForIpo.map((x, i) => {
          x['total'] = this.totals[i].value
          return x
        })
        if (this.form.get('radioValue').value === '1') {
          this.markChartIpo()
        }
      })
    this.cpmService
      .getCapitalValueSO(
        this.form.get('radioValue2').value,
        this.startYear,
        this.endYear
      )
      .subscribe(obj => {
        this.capListso = []
        obj.map(value => {
          this.capListso.push(value)
        })
        this.capHeaderso = obj.map(headercapSo => headercapSo.year)
        this.capTypeso = obj.map(ctypeSo => ctypeSo.type)
        this.capSo = obj.map(capSo => capSo.capitalValue)

        this.capHeaderso = this.capHeaderso.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.capTypeso = this.capTypeso.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.capTypeso.push('Total')
        let list2 = []
        const listTable2 = []
        this.totals2 = this.capHeaderso.map(header2 => {
          list2 = []
          this.capTypeso.map(type2 => {
            this.capListso.map(so => {
              if (header2 === so.year && type2 === so.type) {
                list2.push(so.capitalValue)
              }
            })
          })
          const tmp2 = [...list2]
          tmp2.unshift(header2)
          listTable2.push(tmp2)
          const Total = {
            year: header2,
            value: list2.reduce((a, b) => Math.round(a) + Math.round(b), 0)
          }
          this.showTable2.push(list2)
          this.listSoTable = [...listTable2]
          return Total
        })

        this.dataProviderForSo = this.listSoTable.map((so, i) => {
          const soObj = {
            year: so[0],
            pp: Math.round(so[1]),
            po: Math.round(so[2]),
            ro: Math.round(so[3]),
            sd: Math.round(so[4]),
            xe: Math.round(so[5]),
            other: Math.round(so[6])
          }
          return soObj
        })
        this.dataExportExcelSo = []
        this.dataExportExcelSo = this.dataProviderForSo.map((x, i) => {
          x['total'] = this.totals2[i].value
          return x
        })

        if (this.form.get('radioValue').value === '2') {
          this.markChartSo()
        }
      })
  }
  ngOnDestroy() {
    if (this.chart3 && this.chart3.legend && this.chart3.legend.destroy) {
      const tmp =
        this.chart3 != null ? this.amCharts.destroyChart(this.chart3) : null
    }
  }

  markChartSo() {
    const dataChart = {
      type: 'serial',
      theme: 'none',
      color: 'black',
      fontFamily: 'browallia',
      fontSize: 18,
      categoryField: 'year',
      // startDuration: 1,

      categoryAxis: {
        gridPosition: 'start',
        title: 'Year'
      },

      graphs: [
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');


            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'PP',
          type: 'column',
          color: '#fff',
          fillColors: '#e86712',
          valueField: 'pp',
          borderColor: '#e86712'
        },
        {
          // balloonText:
          // ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {

            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'PO',
          type: 'column',
          color: '#fff',
          fillColors: '#ffa400',
          valueField: 'po',
          borderColor: '#ffa400'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {

            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'RO',
          type: 'column',
          color: '#fff',
          fillColors: '#ffd200',
          valueField: 'ro',
          borderColor: '#ffd200'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {

            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'SD',
          type: 'column',
          color: '#fff',
          fillColors: '#b4975a',
          valueField: 'sd',
          borderColor: '#b4975a'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {

            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'XE',
          type: 'column',
          color: '#fff',
          fillColors: '#231f20',
          valueField: 'xe',
          borderColor: '#231f20'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          lineAlpha: 0,
          title: 'Others',
          type: 'column',
          color: '#fff',
          fillColors: '#5f6062',
          valueField: 'other',
          markerBorderColor: '#5f6062'
        }
      ],
      valueAxes: [
        {
          id: 'ValueAxis-1',
          stackType: 'regular',
          title: this.textMark + ' (M.Baht)'
        }
      ],

      balloon: {},
      legend: {
        enabled: true,
        position: 'bottom',
        align: 'center',
        maxColumns: 3,
        width: 550,
        useGraphSettings: true
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: this.textHeader + ' capital raised by instrument'
        }
      ],

      dataProvider: this.dataProviderForSo
    }

    this.chart3 = this.amCharts.makeChart('chartdiv3', dataChart)

  }

  markChartIpo() {
    const dataChart = {
      type: 'serial',
      theme: 'none',
      color: 'black',
      fontFamily: 'browallia',
      fontSize: 18,
      categoryField: 'year',
      // startDuration: 1,
      categoryAxis: {
        gridPosition: 'start',
        title: 'Year'
      },

      graphs: [
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'SET',
          type: 'column',
          color: '#fff',
          fillColors: '#ffa400',
          valueField: 'set'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'mai',
          type: 'column',
          color: '#fff',
          fillColors: '#ffd200',
          valueField: 'mai'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'IFF',
          type: 'column',
          color: '#fff',
          fillColors: '#5f6062',
          valueField: 'iff'
        },
        {
          // balloonText:
          //   ' <b>[[title]]</b><br><span style="font-size:14px">[[year]]: <b>[[value]]</b></span>',
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'PF&REITs',
          type: 'column',
          color: '#fff',
          fillColors: '#231f20',
          valueField: 'reit'
        }
      ],

      valueAxes: [
        {
          id: 'ValueAxis-1',
          stackType: 'regular',
          title: this.textMark + ' (M.Baht)'
        }
      ],
      allLabels: [],
      balloon: {},
      legend: {
        enabled: true,
        position: 'bottom',
        align: 'center',
        useGraphSettings: true
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: this.textHeader + ' capital raised by instrument'
        }
      ],

      dataProvider: this.dataProviderForIpo
    }
    this.chart3 = this.amCharts.makeChart('chartdiv3', dataChart)
  }

  Ppt() {
    this.pptService.pptCapitalRaisedInstruments(
      this.form.get('radioValue2').value,
      this.form.get('radioValue').value,
      this.dataProviderForIpo,
      this.dataProviderForSo
    )
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  numberWithCommas(value) {
    return this.pptService.numberWithCommas(value, true);
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/capital-raised-instruments/capital-raised-instruments.component.ts